import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import styles from './styles.module.scss';

function InvitationFrom({ handleFormDataFather, handleClickBackFather, handleSaveFormDataFather, data=null, handleLoad=null}) {

  console.log('handleLoad', handleLoad);

  // Estado para almacenar los datos del formulario
  const [formData, setFormData] = useState({
    event_name: '',
    event_date: '',
    time: '',
    celebrate_name: '',
    address: '',
    message: '',
  });

  // Manejar cambios en los campos del formulario
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Manejar el envío del formulario
  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí puedes realizar cualquier acción que desees con los datos del formulario
    console.log('Datos del formulario:', formData);

    // Puedes convertir los datos en formato JSON si es necesario
    const jsonData = JSON.stringify(formData);
    console.log('Datos en formato JSON:', jsonData);
    handleSaveFormDataFather(jsonData);
  };

  useEffect(() => {
    handleFormDataFather(JSON.stringify(formData));
  }, [formData]);

  useEffect(() => {
    if (data) {
    console.log('if data en edit invitacion',data);
    formData.event_name = data?.event_name,
    formData.event_date = data?.event_date,
    formData.time = data?.time,
    formData.celebrate_name = data?.celebrate_name,
    formData.address = data?.address,
    formData.message = data?.message
  };
  },[data]);

  console.log('data en edit invitacion',data);

  return (
    <div className='shadow border rounded'>
      <br />
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <p className="text-left font-weight-bold">Título del evento:</p>
          <input
            type="text"
            name="event_name"
            value={formData.event_name}
            onChange={handleInputChange}
            className={`${styles.inputsborder} form-control`}
            style={{ textAlign: 'left' }}
          />
        </div>
        <div className="form-group">
          <p className="text-left font-weight-bold">Fecha:</p>
          <input
            type="date"
            name="event_date"
            value={formData.event_date}
            onChange={handleInputChange}
            className={`${styles.inputsborder} form-control`}
            style={{ textAlign: 'left' }}
          />
        </div>
        <div className="form-group">
          <p className="text-left font-weight-bold">Hora:</p>
          <input
            type="time"
            name="time"
            value={formData.time}
            onChange={handleInputChange}
            className={`${styles.inputsborder} form-control`}
            style={{ textAlign: 'left' }}
          />
        </div>
        <div className="form-group">
          <p className="text-left font-weight-bold">Nombre de los festejados:</p>
          <input
            type="text"
            name="celebrate_name"
            value={formData.celebrate_name}
            onChange={handleInputChange}
            className={`${styles.inputsborder} form-control`}
            style={{ textAlign: 'left' }}
          />
        </div>
        <div className="form-group">
          <p className="text-left font-weight-bold">Lugar del evento:</p>
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            className={`${styles.inputsborder} form-control`}
            style={{ textAlign: 'left' }}
          />
        </div>
        <div className="form-group">
          <p className="text-left font-weight-bold">Mensaje:</p>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleInputChange}
            className={`${styles.inputsborder} form-control`}
            style={{ textAlign: 'left' }}
          />
        </div>
        <div className="d-flex justify-content-between">
        {handleLoad !== 'load' && (
          <Button
            id={1}
            variant="secondary"
            onClick={handleClickBackFather}
            type="button"
            className="flex-grow-1 mr-2">
            Cambiar tema
          </Button>
          )}
          <Button
            id={11}
            variant="primary"
            onClick={handleSubmit}
            type="button"
            className="flex-grow-1">
            Guardar
          </Button>
        </div>
      </form>
      <br />
    </div>
  );
}

export default InvitationFrom;
